import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import * as _ from 'lodash';
import { PageService } from '../rest/api/page.service';
import {TranslateService} from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-page-details',
  templateUrl: './page-details.component.html',
  styleUrls: ['./page-details.component.scss']
})
export class PageDetailsComponent implements OnInit, OnDestroy {
  lang: any;
  pageLoader = true;
  pageData: any;
  constructor(
    public route: ActivatedRoute,
    public pageService: PageService,
    public translateService: TranslateService,
    public router: Router,
    public sanitizer: DomSanitizer
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => {
      return false;
    };
    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.router.navigated = false;
        window.scrollTo(0, 0);
      }
    });
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.route.params.subscribe(params => {
      if (!params.slug) {
        this.router.navigate(['/']);
      }
      this.getPageDetails(params.slug);
    });
  }
  getPageDetails(slug) {
    this.pageService.getPageMenu({
      slug: slug,
      lang: this.lang
    }).subscribe((response: any) => {
      const pageData = response.data;
      if (pageData && pageData.description) {
        pageData.description = this.sanitizer.bypassSecurityTrustHtml(pageData.description);
      }
      if (pageData && pageData.sub_pages && pageData.sub_pages.length > 0) {
        pageData.sub_pages = _.map(pageData.sub_pages, (data) => {
          if (data && data.description) {
            data.description = this.sanitizer.bypassSecurityTrustHtml(data.description);
          }
          return data;
        });
      }
      this.pageData = pageData;
      this.pageLoader = false;
      this.loadIframeCodes();
    }, err => {
      this.pageLoader = false;
      this.pageData = [];
      this.router.navigate(['/']);
    });
  }

  convertHtml(html) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  loadIframeCodes() {
    setTimeout(() => {
      // tslint:disable-next-line:only-arrow-functions
      $.each( $('iframe'), function(key, value) {
        const pre = document.createElement('pre');
        pre.textContent = value.outerHTML;
        pre.className = 'iframe-div';
        value.before(pre);
        $(pre).insertBefore(value);
      });
    }, 1000);
  }

  removeIframeCodes() {
    const iframes = document.querySelectorAll('iframe');
    let i;
    for (i = 0; i < iframes.length; i++) {
        iframes[i].parentNode.removeChild(iframes[i]);
    }
  }

  ngOnDestroy() {
    this.removeIframeCodes();
  }

}
